import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

import { auth, db } from '../services/firebase';
import { VideoJob } from '../types';

/**
 * Hook to fetch all jobs for the current user in real-time
 * Automatically subscribes to Firestore updates
 *
 * @returns {object} - { jobs, loading, error }
 */
export function useUserJobs() {
  const [jobs, setJobs] = useState<VideoJob[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setJobs([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'jobs'),
      where('userId', '==', user.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const jobList = snapshot.docs.map(
          (doc) =>
            ({
              id: doc.id,
              ...doc.data(),
            }) as VideoJob
        );
        setJobs(jobList);
        setLoading(false);
      },
      (err) => {
        console.error('Error watching jobs:', err);
        setError(err as Error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { jobs, loading, error };
}
